// ---------------------------------------------------------------------------
// Bandera del MODO DEMO (demo.soedia.com).
//
// `import.meta.env.VITE_DEMO_MODE` se resuelve en tiempo de compilación: vale
// 'true' SOLO en el build hecho con `npm run build:demo` (vite --mode demo carga
// .env.demo); en el build normal no está definida → false y las ramas de la demo
// quedan muertas (el chunk de la base demo ni se descarga).
//
// `?? {}`: módulos puros que corren en Node (lib/format.js y sus pruebas) también
// importan esto; allí `import.meta.env` no existe y sin el guardia lanzaría.
// ---------------------------------------------------------------------------
const env = import.meta.env ?? {};

/** true solo en el build de la demo (VITE_DEMO_MODE=true en .env.demo). */
export const DEMO_MODE = env.VITE_DEMO_MODE === 'true';
